'use client'
import { Loader2 } from 'lucide-react'
import { ReactNode, useState } from 'react'
import { Button } from '../button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../dialog'
import { Input } from '../input'
import { Label } from '../label'

export default function ControlledConfirmDeleteDialog({
  open,
  onOpenChange,
  text,
  loading,
  serverAction,
  confirmation,
  confirmationText,
  confirmationMatchText,
  variant = 'destructive',
  buttonText = 'Delete',
}: {
  confirmationMatchText?: string
  confirmation?: boolean
  variant?:
    | 'link'
    | 'destructive'
    | 'calendar'
    | 'transparent'
    | 'default'
    | 'outline'
    | 'secondary'
    | 'ghost'
    | null
    | undefined
  buttonText?: string
  confirmationText?: string
  open: boolean
  onOpenChange: () => void
  text: ReactNode
  loading: boolean
  serverAction: () => void
}) {
  const [match, setMatch] = useState('')
  const normalizeString = (str: string) =>
    str.trim().toLowerCase().replace(/\s+/g, '')

  const isMatch =
    normalizeString(match) === normalizeString(confirmationMatchText ?? '')

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onOpenAutoFocus={(e) => {
          e.preventDefault()
        }}
      >
        <DialogHeader>
          <DialogTitle>{'Are you absolutely sure?'}</DialogTitle>
        </DialogHeader>
        {confirmation && (
          <>
            <div className="grid w-full max-w-sm items-center gap-1.5">
              <Label htmlFor="studentName">{confirmationText}</Label>
              <Input
                name="studentName"
                id="studentName"
                type="text"
                onChange={(e) => {
                  setMatch(e.target.value)
                }}
                placeholder={confirmationMatchText}
              />
            </div>
          </>
        )}
        <DialogDescription>{text}</DialogDescription>
        <DialogFooter className="justify-end">
          <DialogClose className="hidden lg:block" asChild>
            <Button type="button" variant="secondary">
              Cancel
            </Button>
          </DialogClose>
          <Button
            disabled={loading || (confirmation && !isMatch)}
            onClick={async () => {
              await serverAction()
            }}
            variant={variant}
          >
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            {buttonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
